"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leap = void 0;
var is_leap_1 = require("../get-full/leap/is-leap");
var is_persian_leap_1 = require("../get-full/leap/is-persian-leap");
function leap(year, type) {
    if (type === 'fa') {
        return is_persian_leap_1.isPersianLeap(year);
    }
    else {
        return is_leap_1.isLeap(year);
    }
}
exports.leap = leap;
